let previousConnectors = [];
/** https://wagmi.sh/core/api/actions/getConnectors */
export function getConnectors(config) {
    const connectors = config.connectors;
    if (previousConnectors.map((c) => c.uid) === connectors.map((c) => c.uid))
        return previousConnectors;
    previousConnectors = connectors;
    return connectors;
}
//# sourceMappingURL=getConnectors.js.map